// @flow
import * as React from 'react';

import { styled } from '@mui/material/styles';
import MuiChip from '@mui/material/Chip';

export default styled((props) => <MuiChip {...props} label={props.label ? `+${props.label}` : props.label} />)(() => ({
  '& .MuiChip-label': { unicodeBidi: 'plaintext' },
}));
